const initVideos = () => {
    const blocks = document.querySelectorAll('.video__block');
    if (!blocks.length) return;

    const VISIBILITY_THRESHOLD = 0.5;
    const videos = new Map(); // block -> { video, btnPause, btnMute, btnFs }
    let activeBlock = null;

    // === утилиты toggle ===
    const togglePlay = (video, btnPause) => {
        if (video.paused) {
            video.play();
            if (btnPause) btnPause.classList.remove('play');
        } else {
            video.pause();
            if (btnPause) btnPause.classList.add('play');
        }
    };

    const toggleMute = (video, btnMute) => {
        video.muted = !video.muted;
        if (btnMute) btnMute.classList.toggle('on', !video.muted);
        video.volume = video.muted ? 0 : 0.5;
    };

    const toggleFullscreen = (block, btnFs) => {
        if (!block) return;

        if (document.fullscreenElement) {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        } else {
            if (block.requestFullscreen) block.requestFullscreen();
            else if (block.webkitRequestFullscreen) block.webkitRequestFullscreen();
            else if (block.mozRequestFullScreen) block.mozRequestFullScreen();
            else if (block.msRequestFullscreen) block.msRequestFullscreen();
        }

        if (btnFs) btnFs.classList.toggle('on');
    };

    // === обработчик клавиш ===
    document.addEventListener('keydown', (e) => {
        if (!activeBlock) return;
        const data = videos.get(activeBlock);
        if (!data) return;

        const { video, btnPause, btnMute, btnFs } = data;

        switch (e.code) {
            case 'Space':
                e.preventDefault();
                togglePlay(video, btnPause);
                break;
            case 'KeyM':
                e.preventDefault();
                toggleMute(video, btnMute);
                break;
            case 'KeyF':
                e.preventDefault();
                toggleFullscreen(activeBlock, btnFs);
                break;
            case 'Escape':
                if (document.fullscreenElement) toggleFullscreen(activeBlock, btnFs);
                break;
        }
    });

    // === IntersectionObserver для активного блока ===
    const ratios = new Map();
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => ratios.set(entry.target, entry.intersectionRatio));

        let best = null;
        let bestRatio = 0;
        for (const [target, ratio] of ratios.entries()) {
            if (ratio > bestRatio) {
                bestRatio = ratio;
                best = target;
            }
        }

        activeBlock = (best && bestRatio >= VISIBILITY_THRESHOLD) ? best : null;
    }, { threshold: Array.from({ length: 101 }, (_, i) => i / 100) });

    // === инициализация каждого блока ===
    blocks.forEach(block => {
        const video = block.querySelector('video');
        const btnPause = block.querySelector('[data-pause-button]');
        const btnMute = block.querySelector('[data-mute-button]');
        const btnFs = block.querySelector('[data-fullscreen-button]');

        videos.set(block, { video, btnPause, btnMute, btnFs });
        observer.observe(block);

        if (btnPause) btnPause.addEventListener('click', ev => { ev.preventDefault(); togglePlay(video, btnPause); });
        if (btnMute) btnMute.addEventListener('click', ev => { ev.preventDefault(); toggleMute(video, btnMute); });
        if (btnFs) btnFs.addEventListener('click', ev => { ev.preventDefault(); toggleFullscreen(block, btnFs); });

        // синхронизация классов при внешних событиях
        video.addEventListener('play', () => { if (btnPause) btnPause.classList.remove('play'); });
        video.addEventListener('pause', () => { if (btnPause) btnPause.classList.add('play'); });
    });
};

export default initVideos;
